export default [
    {
        path: 'esus-parametrizacao',
        component: () => import(/* webpackChunkName: 'integracao-esus-parametrizacao' */ '@/views/integracao/esus/parametrizacao/Index'),
        redirect: 'esus-parametrizacao/create',
        children: [
            {
                name: 'integracao-esus-parametrizacao-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'integracao-esus-parametrizacao' */ '@/views/integracao/esus/parametrizacao/Form'),
            },
        ],
    },
]